/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const accessCode = (currentUser as any)?.access ?? currentUser?.user?.access;
  return {
    canAdmin: Boolean(currentUser) && accessCode === 'admin',
  };
}
